export const INSTALLMENTS_MIN_AMOUNT = 50;
export const INSTALLMENTS_MAX_AMOUNT = 6000;
